<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="row">
        <div class="col-12">
            <div class="dash-card card-padding-top">
                <ng-container *ngIf="loading">
                    <ngx-skeleton-loader [theme]="{
                                height: '244px',
                                margin:'0 0 24px'
                            }">
                    </ngx-skeleton-loader>
                </ng-container>

                <ng-container *ngIf="!loading">
                    <app-empty-content [isVisible]="data.length === 0"
                        title="Nenhuma minuta encontrada"
                        description="Não foi encontrada nenhuma minuta nesse cadastro"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>

                    <div class="table-scroll-container" *ngIf="data.length > 0">
                        <table class="bordered">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Destino</th>
                                    <th>Última atualização</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of data">
                                    <td>{{item.file}}</td>
                                    <td>{{formatApplicable(item.applicable)}}
                                    </td>
                                    <td>{{formatDate(item.date_updated)}}</td>
                                    <td>
                                        <div class="dash-card-item-buttons">
                                            <button class="dash-item-button"
                                                (click)="handleDelete(item.id)"
                                                *ngIf="canRemove">
                                                <svg-icon
                                                    src="assets/images/icon-trash.svg"></svg-icon>
                                            </button>
                                            <app-spacer
                                                [right]="16"></app-spacer>

                                            <button class="dash-item-button"
                                                (click)="handleOpenVisualizer(item.id)"
                                                *ngIf="canView">
                                                <svg-icon
                                                    src="assets/images/icon-eye.svg"></svg-icon>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <app-spacer [bottom]="28"></app-spacer>
                        </table>
                    </div>
                </ng-container>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <ng-container *ngIf="mainLoading">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!mainLoading">
                <ng-container *ngIf="approvalService.approvalData.mainVersion">
                    <div class="dash-card card-padding-top">
                        <app-empty-content [isVisible]="mainData.length === 0"
                            title="Nenhuma minuta encontrada"
                            description="Não foi encontrada nenhuma minuta nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <div class="table-scroll-container"
                            *ngIf="mainData.length > 0">
                            <table class="bordered">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Destino</th>
                                        <th>Última atualização</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let item of mainData">
                                        <td>{{item.file}}</td>
                                        <td>{{formatApplicable(item.applicable)}}
                                        </td>
                                        <td>{{formatDate(item.date_updated)}}
                                        </td>
                                        <td>
                                            <div class="dash-card-item-buttons">
                                                <button class="dash-item-button"
                                                    (click)="handleOpenVisualizer(item.id)"
                                                    *ngIf="canView">
                                                    <svg-icon
                                                        src="assets/images/icon-eye.svg"></svg-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <app-spacer [bottom]="28"></app-spacer>
                            </table>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!approvalService.approvalData.mainVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container *ngIf="comparingDataLoading">
                <div class="dash-card card-padding-top">
                    <div class="table-scroll-container">
                        <table class="bordered">
                            <thead>
                                <tr>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '200px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '100px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '150px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '50px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let i of [1,2,3]">
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '250px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '100px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '150px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '30px', height: '30px', borderRadius: '50%' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!comparingDataLoading">
                <ng-container
                    *ngIf="approvalService.approvalData.comparingVersion">
                    <div class="dash-card card-padding-top">
                        <app-empty-content
                            [isVisible]="comparingData.length === 0"
                            title="Nenhuma minuta encontrada"
                            description="Não foi encontrada nenhuma minuta nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <div class="table-scroll-container"
                            *ngIf="comparingData.length > 0">
                            <table class="bordered">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Destino</th>
                                        <th>Última atualização</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let item of comparingData"
                                        [class]="item.compareClass"
                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                        <td>
                                            <div
                                                style="display: flex; align-items: center; gap: 6px;">
                                                <svg-icon
                                                    src="assets/images/icon-check-filled.svg"
                                                    *ngIf="item.compareClass === 'row-compare-added'"
                                                    class="text-success"></svg-icon>
                                                <svg-icon
                                                    src="assets/images/icon-times-circle.svg"
                                                    *ngIf="item.compareClass === 'row-compare-removed'"
                                                    class="text-danger"></svg-icon>
                                                <svg-icon
                                                    src="assets/images/icon-warning.svg"
                                                    *ngIf="item.compareClass === 'row-compare-modified' && isFieldChanged(item, 'file')"
                                                    class="text-warning"></svg-icon>
                                                <span>{{item.file}}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                style="display: flex; align-items: center; gap: 6px;">
                                                <svg-icon
                                                    src="assets/images/icon-warning.svg"
                                                    *ngIf="item.compareClass === 'row-compare-modified' && isFieldChanged(item, 'applicable')"
                                                    class="text-warning"></svg-icon>
                                                <span>{{formatApplicable(item.applicable)}}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                style="display: flex; align-items: center; gap: 6px;">
                                                <svg-icon
                                                    src="assets/images/icon-warning.svg"
                                                    *ngIf="item.compareClass === 'row-compare-modified' && isFieldChanged(item, 'date_updated')"
                                                    class="text-warning"></svg-icon>
                                                <span>{{formatDate(item.date_updated)}}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="dash-card-item-buttons">
                                                <button class="dash-item-button"
                                                    (click)="handleOpenVisualizer(item.id)"
                                                    *ngIf="canView">
                                                    <svg-icon
                                                        src="assets/images/icon-eye.svg"></svg-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <app-spacer [bottom]="28"></app-spacer>
                            </table>
                        </div>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="!approvalService.approvalData.comparingVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>

<app-side-modal [active]="showModal"
    [title]="selectedDraft ? 'Atualizar minuta' : 'Adicionar minuta'"
    (onClose)="closeModal()" paddingBottom="30">
    <form [formGroup]="form">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <app-select [items]="funds" label="Selecione um fundo"
                        controlName="fund" [group]="form">
                    </app-select>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <quill-editor [modules]="quillModules"
                        class="editor-container" formControlName="content">
                    </quill-editor>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <div class="variable-container">
                <h4>Variáveis disponíveis</h4>

                <div class="row">
                    <div class="col-12" *ngFor="let item of documentation">
                        <app-collapse [title]="item.name">
                            <ul [ngbCollapse]="">
                                <li *ngFor="let child of item.children">
                                    {{child}}
                                </li>
                            </ul>
                        </app-collapse>

                        <app-spacer [bottom]="16"></app-spacer>
                    </div>
                </div>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="row button-sticky">
                <div class="col-12 col-lg-6">
                    <app-button (onClick)="closeModal()" class="add-button"
                        [outline]="true">
                        Cancelar
                    </app-button>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="text-right">
                        <app-button (onClick)="createTemplate()"
                            [disabled]="getDisabled()" class="add-button">
                            {{selectedDraft ? 'Atualizar template' : 'Criar
                            template'}}
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>